import { compose, identity, path, merge, mergeAll } from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import NumberInput from '../../modules/numberInput.jsx';
import Spinner from '../../modules/Spinner.jsx';
import Alert from 'react-bootstrap/lib/Alert';

export default class EditConsultantForm extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { 
      errorMessage: null
    };
  }
  componentDidMount() {
    $.ajax({
      url: this.props.resourceUrl,
      method: 'GET'
    }).done((consultantResource) => this.setState({ consultantResource }))
    .fail(() => this.setState({ errorMessage: 'No se encontró el consultor.' }));
  }
  render() {
    if (this.state.errorMessage) {
      return <Alert bsStyle="danger" onDismiss={() => this.setState({ errorMessage: null })}>{this.state.errorMessage}</Alert>;
    }

    if (!this.state.consultantResource) {
      return <Spinner />;
    }

    return (
      <form>
        {this.renderNumberInput('Licencias', 'totallicenses')}
      </form>
    );
  }
  renderInput(label, id) {
    const input = <input type='text' value={this.state.consultantResource[id]} onChange={this.handleChange(id, path(['target', 'value']))} />;
    return this.renderRow(label, input);
  }
  renderNumberInput(label, id) {
    const input = <NumberInput value={this.state.consultantResource[id]} onChange={this.handleChange('totallicenses', identity)} min={this.state.consultantResource.usedlicenses} max="10000" />;
    return this.renderRow(label, input);
  }
  renderRow(label, input) {
    return (
      <div className='row form-group'>
        <label className='col-xs-3 col-xs-offset-2' style={{ textAlign: 'right' }}>{label}</label>
        <div className='col-xs-6'>
          {input}
        </div>
      </div>
    );
  }
  handleChange(field, getValue) {
    return (event) => {
      const value = getValue(event);
      this.setState({consultantResource: merge(this.state.consultantResource, { [field]: value })});
      this.props.onChange(mergeAll([this.props.value, this.state.consultantResource, { [field]: value }]));
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/consultants/EditConsultantForm.jsx